import { render, staticRenderFns } from "./ShowStudentCourse.vue?vue&type=template&id=5b6284f2&"
import script from "./ShowStudentCourse.vue?vue&type=script&lang=js&"
export * from "./ShowStudentCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports